import { Component, Input, OnInit } from '@angular/core';
import { MySpaceConstants } from '../../my-space-constants';

@Component({
  selector: 'app-training-quiz-answer',
  templateUrl: './training-quiz-answer.component.html',
  styleUrls: ['./training-quiz-answer.component.scss']
})
export class TrainingQuizAnswerComponent implements OnInit {
  @Input() quizData : any;
  @Input() quizResponse : any;
  isQuizReadOnly : boolean = false;
  isQuizVisible : boolean = false;
  instructionToCloseModal : string = MySpaceConstants.TrainingQuizAnswerModal_InstructionToClose
 
  constructor() {
    
  }
  ngOnInit(){
    this.isQuizReadOnly = true;
    this.isQuizVisible=true;
  }

}
